import { useCallback } from "react";

type HasSetNo = { set_no: number };

const useFormItemEditor = <T extends HasSetNo>(
  items: T[],
  setItems: (items: T[]) => void,
  createItem: (set_no: number) => T,
) => {
  const updateItem = useCallback(
    (index: number, patch: Partial<T>) => {
      setItems(items.map((it, i) => (i === index ? { ...it, ...patch } : it)));
    },
    [items, setItems],
  );

  const addItem = useCallback(() => {
    setItems([...items, createItem(items.length + 1)]);
  }, [items, setItems, createItem]);

  const removeItem = useCallback(
    (index: number) => {
      if (items.length <= 1) return;
      const next = items.filter((_, i) => i !== index);
      setItems(next.map((it, i) => ({ ...it, set_no: i + 1 })));
    },
    [items, setItems],
  );

  return { updateItem, addItem, removeItem };
};

export default useFormItemEditor;
